/* eslint-disable react/prefer-stateless-function */
import React from 'react';
import { connect } from 'react-redux';
import { ProposalTemplate, ProposalBuilderVersion } from '../../modules/proposal/Proposal';
import { ReduxState } from '../../redux/modules/types';
import { API_URL } from '@/utils/api';

type StateProps = {
  template?: ProposalTemplate;
};

type Props = StateProps & {
  onLoad: () => void;
  onError: () => void;
};

const ProposalStyleLoader = ({ template, onLoad, onError }: Props) => {
  if (!template || template.builderVersion !== ProposalBuilderVersion.V2 || !template.styleUrl) {
    return null;
  }

  return <link onLoad={onLoad} onError={onError} key={template.key} rel="stylesheet" type="text/css" href={API_URL + template.styleUrl} />;
};

const mapStateToProps = (state: ReduxState) => ({
  template: state.proposalV2.selectedTemplate,
});

export default connect(mapStateToProps, null)(ProposalStyleLoader);
